import React, { useEffect, useRef, useState } from "react";
import { CommentCard, EventCard } from "./";

export const Footer = ({
  nextEvent,
  upcomingEvents,
  upcomingComments,
  firstPhaseDescription,
  secondPhaseDescription,
  setDateFromState,
  setDateToState,
  horizontalScrollRef,
  annualPlannerMainRef,
}) => {
  const [commentsAmount, setCommentsAmount] = useState(0);
  const firstColumnRef = useRef();
  const secondColumnRef = useRef();

  useEffect(() => {
    if (firstColumnRef.current && secondColumnRef.current)
      secondColumnRef.current.style.height = `
      ${firstColumnRef.current.offsetHeight}px`;
  }, [commentsAmount]);

  useEffect(() => {
    if (firstColumnRef.current && secondColumnRef.current)
      secondColumnRef.current.style.height = `
      ${firstColumnRef.current.offsetHeight}px`;
  }, [upcomingComments]);

  return (
    <React.Fragment>
      {nextEvent ||
      upcomingEvents.length ||
      upcomingComments.length ||
      firstPhaseDescription ||
      secondPhaseDescription ? (
        <section role="footer" className="mobile-hidden">
          <span role="footer-header">Events, Comments and Other</span>
          <div role="footer-content">
            <div className="main">
              <div role="column" className="first" ref={firstColumnRef}>
                {nextEvent ? (
                  <div className="next-event-section">
                    <span className="footer-section-header">Next event</span>
                    <EventCard
                      event={nextEvent}
                      type="next"
                      setDateFromState={setDateFromState}
                      setDateToState={setDateToState}
                      horizontalScrollRef={horizontalScrollRef}
                      annualPlannerMainRef={annualPlannerMainRef}
                    />
                  </div>
                ) : null}
                {firstPhaseDescription && (
                  <div className="comments-section">
                    <span className="footer-section-header">Comments</span>
                    <CommentCard comment={firstPhaseDescription} />
                    {secondPhaseDescription && (
                      <CommentCard comment={secondPhaseDescription} />
                    )}
                    {Array.from(
                      Array(commentsAmount).keys(),
                      (commentIndex) => {
                        if (upcomingComments[commentIndex])
                          return (
                            <CommentCard
                              comment={upcomingComments[commentIndex]}
                            />
                          );
                        return null;
                      }
                    )}
                  </div>
                )}
                {commentsAmount < upcomingComments.length && (
                  <button
                    className="button-input"
                    onClick={() => {
                      setCommentsAmount(commentsAmount + 3);
                    }}
                  >
                    See more comments
                  </button>
                )}
              </div>
              {upcomingEvents.length ? (
                <div role="column" className="second" ref={secondColumnRef}>
                  <div className="upcoming-events-section">
                    <span className="footer-section-header">
                      Upcoming events
                    </span>
                    <div className="upcoming-events-cards-wrapper">
                      {upcomingEvents.map((upcomingEvent, index) => (
                        <EventCard
                          key={`upcoming-event-${index}`}
                          event={upcomingEvent}
                          type="upcoming"
                          setDateFromState={setDateFromState}
                          setDateToState={setDateToState}
                          horizontalScrollRef={horizontalScrollRef}
                          annualPlannerMainRef={annualPlannerMainRef}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="footer-content-see-more"></div>
          </div>
        </section>
      ) : null}
    </React.Fragment>
  );
};
